import { render, staticRenderFns } from "./RegionesTab.vue?vue&type=template&id=4bfa5f21"
import script from "./RegionesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionesTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports